export default function sortFetchedList(fetchedList){
    fetchedList.sort((a: any, b: any) => {
        let keyA = a.version;
        let keyB = b.version;
        if (keyA > keyB) return -1;
        if (keyA < keyB) return 1;
        return 0;
      });
      return fetchedList;
}